import dayjs from "dayjs";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { ProjectJoinDateForm } from "./Form";
import { AccountType } from "../../../../../models/AccountData";
import {
  ProjectsLocationsData,
  UpdateProjectLocationPayload
} from "../../../../../models/ProjectData";
import { OptionalRender } from "../../../../Common/OptionalRender";
import { useProjectsLocations } from "../../hooks";
import "./styles.scss";

interface IProjectJoinDateProps {
  organizationId: string;
  projectLocation?: ProjectsLocationsData;
}

export const ProjectJoinDate: React.FC<IProjectJoinDateProps> = ({
  organizationId,
  projectLocation
}) => {
  const { t: _t } = useTranslation();
  const t = (key: string) =>
    _t(
      `projectManagementPage.projectFacilityDetailsModal.projectJoinDate.${key}`
    );

  const [isEditMode, setIsEditMode] = useState(false);

  const { updateProjectLocation } = useProjectsLocations(
    organizationId,
    projectLocation?.project_id.toString()
  );

  const handleEdit = () => {
    setIsEditMode((v) => !v);
  };

  const handleClose = () => {
    setIsEditMode(false);
  };

  const handleSubmit = async (payload: UpdateProjectLocationPayload) => {
    await updateProjectLocation({
      projectLocationId: projectLocation?.id.toString(),
      payload
    });
    handleClose();
  };

  return (
    <>
      <div className="project-join-date">
        <span>{t("registered")}</span>
        <span>
          {dayjs(projectLocation?.project_join_date).format("YYYY/MM/DD")}
        </span>
        <OptionalRender mustBeOneOfRoles={[AccountType.ADMIN]}>
          <button className="edit-button" onClick={handleEdit}></button>
        </OptionalRender>
      </div>
      {isEditMode && projectLocation && (
        <ProjectJoinDateForm
          projectLocation={projectLocation}
          handleClose={handleClose}
          handleSubmit={handleSubmit}
        />
      )}
    </>
  );
};
